import { Portfolio } from '@qvs/core';

export class PortfolioComparator {
  static portfolioComparatorByName(a: Portfolio, b: Portfolio) {
    if (a.name?.toLowerCase() < b.name?.toLowerCase()) {
      return -1;
    }
    if (a.name?.toLowerCase() > b.name?.toLowerCase()) {
      return 1;
    }
    return 0;
  }
}
